// 「加到主畫面」引導：手機瀏覽器、還沒從主畫面開啟時，在首頁上方提示
// 對應 docs/PRD-Freemium.md 第 8.4 節、docs/PWA.md
//
// - Android Chrome：攔下 beforeinstallprompt，按鈕直接跳出安裝
// - iPhone／iPad Safari：沒有安裝 API，用大字說明「分享 → 加入主畫面」
// - 7 天最多提示一次；已從主畫面開啟（standalone）就不提示
//
// === 使用圖片 ===
// 無 — 純程式繪製（DOM overlay，不經 Phaser）

import { showNotice } from './notice-toast';

const HINT_ID = 'mahjong-install-hint';
const HINT_SHOWN_KEY = 'mahjongking.install-hint-at';
const HINT_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000; // 再次提示間隔
const HINT_Z_INDEX = '1800';
const HINT_FONT_PX = 22;
const BUTTON_FONT_PX = 22;
const RED = '#a0322a';

interface IInstallPromptEvent extends Event {
  prompt(): Promise<void>;
}

let deferredPrompt: IInstallPromptEvent | null = null;

/** 程式一開始就要掛上，否則會錯過 Chrome 的 beforeinstallprompt。 */
export const installPromptListener = (): void => {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event as IInstallPromptEvent;
  });
};

const isStandalone = (): boolean =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.matchMedia('(display-mode: fullscreen)').matches ||
  (navigator as { standalone?: boolean }).standalone === true;

const isTouchPhone = (): boolean => window.matchMedia('(pointer: coarse)').matches;
const isIOS = (): boolean => /iPhone|iPad|iPod/i.test(navigator.userAgent);

const shownRecently = (): boolean => {
  try {
    return Date.now() - Number(localStorage.getItem(HINT_SHOWN_KEY) ?? 0) < HINT_INTERVAL_MS;
  } catch {
    return true;
  }
};

export const maybeShowInstallHint = (): void => {
  if (typeof document === 'undefined' || document.getElementById(HINT_ID)) return;
  if (isStandalone() || !isTouchPhone() || shownRecently()) return;
  try {
    localStorage.setItem(HINT_SHOWN_KEY, String(Date.now()));
  } catch {
    /* 寫不進去就每次提示，影響不大 */
  }
  const bar = document.createElement('div');
  bar.id = HINT_ID;
  Object.assign(bar.style, {
    position: 'fixed',
    top: '12px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: HINT_Z_INDEX,
    background: 'rgba(255, 248, 236, 0.97)',
    border: '3px solid #e7c26b',
    borderRadius: '16px',
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#3a2a1a',
    fontFamily: '"PingFang TC", "Microsoft JhengHei", system-ui, sans-serif',
    fontSize: `${HINT_FONT_PX}px`,
    boxShadow: '0 6px 20px rgba(0,0,0,.3)',
    maxWidth: '92vw',
  });
  const text = document.createElement('span');
  text.textContent = '把麻將王加到手機主畫面，下次一點就開';
  const add = document.createElement('button');
  add.textContent = '加到主畫面';
  Object.assign(add.style, {
    fontSize: `${BUTTON_FONT_PX}px`,
    padding: '8px 16px',
    borderRadius: '12px',
    border: 'none',
    background: RED,
    color: '#fff',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  });
  const close = document.createElement('button');
  close.textContent = '×';
  Object.assign(close.style, {
    fontSize: '28px',
    border: 'none',
    background: 'transparent',
    color: '#8a7660',
    padding: '0 4px',
  });
  add.addEventListener('click', () => {
    bar.remove();
    if (deferredPrompt) {
      void deferredPrompt.prompt();
      deferredPrompt = null;
    } else if (isIOS()) {
      showNotice('點下方的「分享」按鈕\n再選「加入主畫面」');
    } else {
      showNotice('點瀏覽器右上角的選單\n再選「加到主畫面」');
    }
  });
  close.addEventListener('click', () => bar.remove());
  bar.append(text, add, close);
  document.body.append(bar);
};
